import { LeaveApplicationModal } from 'modules/hr/attendance/components';
import { VoucherRequestModal } from 'modules/hr/vouchers/components';

export default function QuickActionsWidget() {
  return (
    <>
      <div className='row row--end gap-3'>
        <LeaveApplicationModal />
        <VoucherRequestModal />
      </div>
    </>
  );
}
